import { BASE_URL, VENDOR_ASSESSMENT_TYPE } from "constants/api";
import axios from "../helpers/axiosInstance";
import { HeadCell } from "models/app";
// import { IVendorAssessmentType, IVendorAssessmentTypeInput } from "models/vendorAssessmentType";
import { IVendorAssessmentType, IVendorAssessmentTypeInput } from "models/vendorAssessmentType";

export async function getVendorAssessmentTypes(params: string = "") : Promise<IVendorAssessmentType[]> {
  const response = await axios.get(BASE_URL + VENDOR_ASSESSMENT_TYPE + params);
  return response.data;
}
export async function addVendorAssessmentType(data: IVendorAssessmentTypeInput) {
  const response = await axios.post(BASE_URL + VENDOR_ASSESSMENT_TYPE, data);
  return response.data;
}
export async function editVendorAssessmentType(data: IVendorAssessmentTypeInput, id: string) {
  
  const response = await axios.patch(BASE_URL + VENDOR_ASSESSMENT_TYPE + "/" + id, data);
  return response.data;
}

export async function deleteVendorAssessmentType(id: string) {
  const response = await axios.delete(BASE_URL + VENDOR_ASSESSMENT_TYPE + "/" + id);
  return response.data;
}

export const VendorAssessmentTypeCells: HeadCell[] = [
  {
    id: "name",
    numeric: false,
    disablePadding: false,
    label: "T_name",
  },
  {
    id: "nameAr",
    numeric: false,
    disablePadding: false,
    label: "T_name_Ar",
  },
   {
    id: "isPretest",
    numeric: false,
    disablePadding: false,
    label: "T_is_pretest",
  },
   {
    id: "isPosttest",
    numeric: false,
    disablePadding: false,
    label: "T_is_posttest",
  },
   {
    id: "isCertifiedtest",
    numeric: false,
    disablePadding: false,
    label: "T_is_certifiedtest",
  },
   {
    id: "isPsychometrictest",
    numeric: false,
    disablePadding: false,
    label: "T_is_psychometrictest",
  },
  
  {
    id: "actions",
    numeric: false,
    disablePadding: false,
    label: "T_action",
  },
];
